module.exports = __webpack_public_path__ + "static/ps-gestion-des-emploies_fr-1aeaeb15551f8c1d03baab359cc4c565.png";